module.exports = __webpack_public_path__ + "static/picturedigits.full-e6968d6d51c7b43886ded764137fe77d.svg";